import { writable, get } from 'svelte/store';
import { loadOfficialBoardRecords, loadCategories } from '../api/api';
import { createUrlParamsString, updateUrlParam } from '../../../core/helpers/url.helper';
import { scrollToElement, windowPushHistory } from '../../../core/helpers/window.helper';
export default class SearchService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        this._pager = writable({ page: 1, perPage: 10 });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._list = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this._active = writable(false);
        this._isFilterActive = writable(false);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._categories = writable([]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._categoriesIfArchiveIncluded = writable([]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._categoryList = writable([]);
        this._areLoadedCategories = writable(false);
        this._areLoadedCategoriesIfArchiveIncluded = writable(false);
        this._errorCategories = writable(false);
        this._processingCategories = writable(false);
        this.submitFromUrl();
    }
    async loadCategories(archiveIncluded) {
        if (archiveIncluded && get(this._areLoadedCategoriesIfArchiveIncluded)) {
            this._categoryList.set(get(this._categoriesIfArchiveIncluded));
            return;
        }
        if (!archiveIncluded && get(this._areLoadedCategories)) {
            this._categoryList.set(get(this._categories));
            return;
        }
        this._processingCategories.set(true);
        const loadCategoriesParams = {
            groupId: this._dataProvider.groupId,
            archived: archiveIncluded,
        };
        await loadCategories(loadCategoriesParams)
            .then((response) => {
            const categories = response.results.map(x => {
                return {
                    id: x.id,
                    name: x.nazev,
                };
            });
            if (archiveIncluded) {
                this._categoriesIfArchiveIncluded.set(categories);
                this._areLoadedCategoriesIfArchiveIncluded.set(true);
            }
            else {
                this._categories.set(categories);
                this._areLoadedCategories.set(true);
            }
            this._categoryList.set(categories);
            this._errorCategories.set(false);
        })
            .catch(() => this._errorCategories.set(true))
            .finally(() => this._processingCategories.set(false));
    }
    submitSearch() {
        const params = {
            q: this._dataProvider.searchString,
            oblast: this._dataProvider.field,
            kategorie: this._dataProvider.category,
            archived: this._dataProvider.archiveIncluded,
        };
        windowPushHistory(createUrlParamsString(params));
        this.setPage(1);
        this._active.set(true);
        this.loadSearchResults();
    }
    goToPage(page) {
        windowPushHistory(updateUrlParam("strana", page));
        this.setPage(page);
        this.scrollToFilter();
        this.loadSearchResults();
    }
    changePageSize(pageSize) {
        windowPushHistory(updateUrlParam("pocet", pageSize));
        this.setPageSize(pageSize);
        this.goToPage(1);
    }
    submitFromUrl() {
        this._dataProvider.searchString = this._dataProvider.searchParameterFromUrl;
        this._dataProvider.field = this._dataProvider.fieldParameterFromUrl;
        this._dataProvider.category = this._dataProvider.categoryParameterFromUrl;
        this._dataProvider.archiveIncluded = this._dataProvider.archiveIncludedParameterFromUrl;
        const urlPage = this._dataProvider.pageParameterFromUrl;
        if (urlPage)
            this.setPage(urlPage);
        const urlPageSize = this._dataProvider.pageSizeParameterFromUrl;
        if (urlPageSize)
            this.setPageSize(urlPageSize);
        this._active.set(true);
        this.loadCategories(this._dataProvider.archiveIncluded)
            .finally(() => {
            this.loadSearchResults();
        });
    }
    loadSearchResults() {
        var _a;
        this._processing.set(true);
        const isCategoryValid = this.dataProvider.category && ((_a = get(this._categoryList)) === null || _a === void 0 ? void 0 : _a.some(category => category.id === this.dataProvider.category));
        const filterParams = {
            query: this.dataProvider.searchString,
            fieldId: this.dataProvider.field || '',
            categoryId: isCategoryValid ? this.dataProvider.category : '',
            archiveIncluded: this.dataProvider.archiveIncluded || false,
            groupId: this.dataProvider.groupId,
            showSiteUrl: this.dataProvider.showSiteUrl,
            pager: this.pager,
        };
        loadOfficialBoardRecords(filterParams)
            .then((response) => {
            this._list.set(response.results);
            this._pager.set(Object.assign(Object.assign({}, this.pager), { total: response.total }));
            this._total.set(response.total);
            this._error.set(false);
            this._isFilterActive.set(!!(filterParams.fieldId || filterParams.categoryId || filterParams.archiveIncluded || filterParams.query));
            // @ts-ignore
            setTimeout(() => removeClickFocus(), 100);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    scrollToFilter() {
        scrollToElement(this.dataProvider.filterEl, 20);
    }
    setPage(page) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { page }));
    }
    setPageSize(perPage) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { perPage }));
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get listSubs() {
        return this._list;
    }
    get activeSubs() {
        return this._active;
    }
    get isFilterActiveSubs() {
        return this._isFilterActive;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get processingSubs() {
        return this._processing;
    }
    // categories
    get categoriesSubs() {
        return this._categories;
    }
    get categoriesIfArchiveIncludedSubs() {
        return this._categoriesIfArchiveIncluded;
    }
    get categoryListSubs() {
        return this._categoryList;
    }
    get errorCategoriesSubs() {
        return this._errorCategories;
    }
    get processingCategoriesSubs() {
        return this._processingCategories;
    }
    // pager
    get pagerSubs() {
        return this._pager;
    }
    get pager() {
        return get(this._pager);
    }
}
